/* @flow */

import Pjax from 'pjax';

// eslint-disable-next-line no-new
new Pjax({
  elements: '[data-type=dynamic-link]',
  selectors: ['[data-behavior=dynamic-container]']
});
